import React from "react";
import { Box, Button, Paper, Typography } from '@mui/material';
import { useStore } from "..";
import { getTimeRangeText, initialState } from "../helpers";
import AppointmentDate from "@utils/appointmentDate";
import DayTimeRadios from "../DayTimeRadios";
import { useAppSelector } from "@store/hooks";
import useDebugInformation from './../../../../../../../../../hooks/useDebugInformation';

const name = "CalendarSelectorElement";

const options: Intl.DateTimeFormatOptions = { weekday: 'long', year: undefined, month: 'long', day: 'numeric' };

// below emergencyEnabled array should make a part of database jobTypeCodes and be fetched from there
// to make it dynamic and database driven
const emergencyEnabled = ["PLTFP",
    "DREXT",
    "DRINT",
    "LRGAI",
    "LREPL",
    "LREPA",
    "LRGCL",
    "LRGML",
    "HBGAS",
    "HRLEK",
    "PLCYL",
    "PLPIP",
    "PLPIS",
    "PLTNK",
    "EEXXX",
    "PLTFF",]

interface CalendarSelectorElementProps {
    parent: string;
}

const CalendarSelectorElement: React.FC<CalendarSelectorElementProps> = ({ parent }) => {
    const [appointmentDate, , setAll] = useStore((store) => store['appointmentDate']);
    const [appointmentTime,] = useStore((store) => store['appointmentTime']);
    const [, setEmergencyOpen] = useStore((store) => store['emergencyOpen']);
    const [emergency,] = useStore((store) => store['emergency']);
    const problemComboJob = useAppSelector(({ ui }) => ui.ProblemComboJob);
    const restrictionExpiresIn30Days = useAppSelector(({ state }) => state.RestrictionExpiresIn30Days)

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { debugName, appointmentDate, appointmentTime, emergency, problemComboJob })

    React.useEffect(() => {
        // initial state
        setAll(initialState())
        return () => {
            // cleanup
            setAll({
                appointmentDate: undefined,
                appointmentTime: "am",
                appointmentRadios: {
                    am: false,
                    pm: false,
                    eve: false,
                },
                emergency: false,
                emergencyOpen: false,
            })
        }
    }, [setAll])

    return (
        <Box sx={{ minWidth: "19rem" }}>
            <Paper elevation={2} sx={{ p: 1 }}>
                <Typography variant="h6">
                    {appointmentDate ? "Appointment Date:" : "Select a date"}
                </Typography>
                {
                    appointmentDate && <Typography variant="h6">
                        {appointmentDate ? new Date(appointmentDate).toLocaleDateString("en-GB", options) : ""}
                    </Typography>
                }
                {
                    appointmentDate && <Typography variant="h6">
                        {appointmentTime ? <span style={{ color: emergency ? "red" : "unset" }}>{`${AppointmentDate.getTimeRequirementType(emergency, appointmentDate).name} - ${appointmentTime.toUpperCase()}`}</span> : ""}
                    </Typography>
                }
                {
                    appointmentDate && <Typography variant="h6">
                        {appointmentTime ? getTimeRangeText(appointmentTime) : ""}
                    </Typography>
                }
            </Paper>
            {appointmentDate && <DayTimeRadios parent="" row />}
            {emergencyEnabled.includes(problemComboJob!.jobTypeCode) && restrictionExpiresIn30Days === -1 && <Paper elevation={2} sx={{ p: 1, mt: 1, textAlign: "center" }}>
                <Button variant="contained" color="error" onClick={() => setEmergencyOpen({ emergencyOpen: true })}>EMERGENCY</Button>
            </Paper>}
        </Box>)
}

CalendarSelectorElement.displayName = name;

export default React.memo(CalendarSelectorElement);